export default "/_next/static/chunks/fonts/AlegreyaSans-Bold-latin-9a3b72e895b035145b062770a2928df6.woff2";